<template>
  <div class="flex flex-col justify-center items-center absolute inset-0 bg-background">
    <div class="form-card">
      <div class="w-32 mx-auto">
        <logo-icon class="w-full" />
      </div>

      <h2 class="mx-auto text-center">Accede a tu cuenta</h2>

      <form @submit.prevent="login" class="flex flex-col w-full">
        <div class="flex flex-col w-full mt-6">
          <label for="email">Correo electrónico</label>
          <input id="email" type="email" v-model="form.email" />
          <validation-errors :errors="errorFor('email')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="password">Contraseña</label>
          <input id="password" type="password" v-model="form.password" />
          <validation-errors :errors="errorFor('password')"></validation-errors>
        </div>

        <primary-button type="submit" class="w-full mt-10" :loading="loading"
          >Iniciar Sesión
        </primary-button>
      </form>
    </div>
  </div>
</template>

<script>
import LogoIcon from "@/icons/LogoIcon";
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { mapState } from "vuex";
export default {
  name: "Login",

  components: {
    LogoIcon,
  },

  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      loading: false,
    };
  },

  computed: {
    ...mapState({
      user: "user",
    }),
  },

  mixins: [validationErrors],

  created() {
    if (this.user) {
      this.$router.push({ name: "home" });
    }
  },

  methods: {
    validateForm() {
      this.errors = {};

      this.validateEmail(this.form.email);
      this.validateLoginPassword(this.form.password);

      return Object.keys(this.errors).length === 0;
    },

    async login() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.loading = true;

      try {
        const response = await api.auth.login(this.form);

        if (
          response.user.type !== "admin"
        ) {
          this.$store.dispatch("errorSnack", "Autenticación inválida");
          return;
        }

        this.$store.dispatch("login", response);
      } catch (error) {
        console.error("Login error:", error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message || error?.message);
        return;
      }

      this.$router.push({ name: "home" });

      this.loading = false;
    },
  },
};
</script>
